import { servesPages } from "../pages/project-pages";

/**
 * Structural subset of a division needed to resolve its base (light) brandkit
 * theme. Kept minimal so both the api-private and api-public `DivisionEntity`
 * shapes (server render vs. client config blob) satisfy it.
 */
interface BaseBrandkitDivisionLike {
  workspaceEnabled?: boolean;
  pagesEnabled?: boolean;
  defaultBrandkit?: { id?: string } | null;
  company?: { defaultBrandkit?: { id?: string } | null } | null;
}

/**
 * The brandkit id that should drive the base (light) theme of a project that
 * serves pages.
 *
 * Such projects inherit the organization's default brandkit, unless the
 * project overrides it with its own default brandkit. Both are emitted as
 * `[data-theme="<brandkitId>"]` variable blocks by `buildThemeBlocks`
 * (`themeableBrandkits` carries org kits into projects with pages), so the id
 * this returns always resolves to a real rule.
 *
 * Returns `undefined` for projects without pages (they keep the plain
 * light/dark body theme) and for projects with pages but no brandkit at all
 * (the caller falls back to `preferredColorTheme` / `"light"`).
 */
export function resolveWorkspaceBaseBrandkitId(
  division: BaseBrandkitDivisionLike | undefined
): string | undefined {
  if (!division || !servesPages(division)) return undefined;
  return (
    division.defaultBrandkit?.id ||
    division.company?.defaultBrandkit?.id ||
    undefined
  );
}
